import Vue from 'vue';
import Resource from 'vue-resource';
import App from './App.vue';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
import config from './config';
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSortDown,
    faSortUp,
    faDownload,
    faSort,
    faCheck,
    faExpandAlt,
    faCompressAlt,
    faPlus,
    faEdit,
    faFileDownload,
} from '@fortawesome/free-solid-svg-icons'
import {  faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueToastr from 'vue-toastr';
import { i18n, i18nMixin } from './i18n';
import LoadingIndicator from './components/LoadingIndicator.vue';
import { auth, initializeApp } from 'firebase';

let app = '';

library.add(
    faExpandAlt,
    faCompressAlt,
    faPlus,
    faCheckSquare,
    faSquare,
    faCheck,
    faEdit,
    faFileDownload,
    faSortDown,
    faSort,
    faSortUp,
    faDownload
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Resource);
Vue.use(BootstrapVue);

Vue.use(VueToastr);


Vue.component('pw-c-loading-indicator', LoadingIndicator);

Vue.config.productionTip = false;

// Initialize Firebase
initializeApp(config.firebase);

auth().onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            el: '#app',
            mixins: [
                i18nMixin
            ],
            i18n,
            router,
            render: (h) => h(App),
        });
    }
});
